import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Paper, BottomNavigation, BottomNavigationAction } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GroupIcon from '@mui/icons-material/Group';
import BusinessIcon from '@mui/icons-material/Business';
import TimelineIcon from '@mui/icons-material/Timeline';
import PaymentIcon from '@mui/icons-material/Payment';

// Same menu items as the sidebar
const menuItems = [
  { label: 'Dashboard', value: '/dashboard', icon: <DashboardIcon /> },
  { label: 'Trends', value: '/dashboard/trends', icon: <TimelineIcon /> },
  { label: 'Orgs', value: '/dashboard/organizations', icon: <BusinessIcon /> }, // Shorter label for bottom nav
  { label: 'Users', value: '/dashboard/users', icon: <GroupIcon /> },
  { label: 'Billing', value: '/dashboard/billing', icon: <PaymentIcon /> },
];

const DashboardBottomNav: React.FC = () => {
  const location = useLocation();

  // Determine the active value based on the current path
  // This handles nested routes like /dashboard/users/some-id by matching the base path
  const currentPath = menuItems.reduce((acc, item) => {
    // Check if the current location starts with the item's value
    // And ensure we take the longest match (e.g., /dashboard/users over /dashboard)
    if (location.pathname.startsWith(item.value) && item.value.length > acc.length) {
        return item.value;
    }
    return acc;
  }, '/dashboard'); // Default to '/dashboard' (Overview) if no better match

  return (
    <Paper
      sx={{
        position: 'fixed', // Fixes to the bottom of the viewport
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.appBar, // Ensures it's above most other content
        display: { xs: 'block', md: 'none' } // IMPORTANT: Only show on mobile
      }}
      elevation={3}
    >
      <BottomNavigation
        showLabels // Always show labels
        value={currentPath} // The 'value' prop controls which action is highlighted
      >
        {menuItems.map((item) => (
          <BottomNavigationAction
            key={item.label}
            label={item.label}
            value={item.value} // This value is compared against the BottomNavigation's value
            icon={item.icon}
            component={RouterLink} // Use RouterLink for navigation
            to={item.value} // Set the destination path
            sx={{
              // Optional: Add specific styles for the selected state if needed
              // '&.Mui-selected': {
              //   color: 'primary.main', // Example: Use primary color when selected
              // }
            }}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
};

export default DashboardBottomNav; 